import { render, staticRenderFns } from "./OrderInfoCoupon.vue?vue&type=template&id=fe87bb32&scoped=true&"
import script from "./OrderInfoCoupon.vue?vue&type=script&lang=js&"
export * from "./OrderInfoCoupon.vue?vue&type=script&lang=js&"
import style0 from "./OrderInfoCoupon.vue?vue&type=style&index=0&id=fe87bb32&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe87bb32",
  null
  
)

export default component.exports